import React, { useState, useCallback, useEffect } from 'react';
import { Link } from "react-router-dom"
import Logo from '../images/BDLogo.png'
import FBLogo from "../images/facebook.svg"
import InstaLogo from "../images/instagram.svg"
import TwitterLogo from "../images/twitter.svg"
import {motion, useScroll, useTransform} from 'motion/react'

// eslint-disable-next-line no-unused-vars
const useMediaQuery = (width) => {
  const [targetReached, setTargetReached] = useState(false);

  const updateTarget = useCallback((e) => {
    if (e.matches) {
      setTargetReached(true);
    } else {
      setTargetReached(false);
    }
  }, []);

  useEffect(() => {
    const media = window.matchMedia(`(max-width: ${width}px)`);
    media.addEventListener("change", updateTarget);

    if (media.matches) {
      setTargetReached(true);
    }

    return () => media.removeEventListener("change", updateTarget);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return targetReached;
};



function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const {scrollY} = useScroll();
  const navHeight = useTransform(scrollY, [0, 100], [130, 100], { clamp: true });
  // eslint-disable-next-line no-unused-vars
  const paddingY = useTransform(scrollY, [0, 100], [24, 18], { clamp: true });
  const logoScale = useTransform(scrollY, [0, 100], [1, 0.66], { clamp: true });
  const logoX = useTransform(scrollY, [0, 100], [0, -20], { clamp: true });
  // eslint-disable-next-line no-unused-vars
  const linksY = useTransform(scrollY, [0, 100], [0, -10], { clamp: true });
  return (
    <main>
      <motion.header>
        <motion.nav style={{ height: navHeight }} className="fixed top-0 flex flex-row min-w-full justify-between bg-blue-900 items-center z-100">
           <motion.div className="flex h-full w-full items-center">
              <motion.div style={{ scale: logoScale, x: logoX }} className="p-0">
                <Link to='/'><img className='w-30 m-2 mt-0' src={Logo} alt="BD Logo"></img></Link>
              </motion.div>
              <div className="flex text-white text-xl w-full justify-end h-full items-center">
                <ul className="flex flex-row items-center between text-white h-full">
                  <li className=' hover:bg-gray-400 rounded-xl flex'>
                    <Link className='px-7 py-3' to="/locations">Our Locations</Link>
                  </li>
                  <li className='hover:bg-gray-400 rounded-xl flex'>
                    <Link className='px-7 py-3' to="/contact">Contact</Link>
                  </li>
                  <li className='hover:bg-gray-400 rounded-xl flex'>
                    <Link className='px-7 py-3' to="/apply">Apply</Link>
                  </li>
                  <li>
                    <button onMouseEnter={() => setDropdownOpen(true)} onMouseLeave={() => setDropdownOpen(false)} data-dropdown-toggle="dropdown" className="inline-flex items-center justify-center text-white shadow-xs leading-5 px-7 py-3 hover:bg-gray-400 rounded-xl "  type="button">
                      Learn More
                      <svg className="w-4 h-4 ms-1.5 -me-0.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 9-7 7-7-7"/></svg>
                    </button>
                    {
                      dropdownOpen &&
                      <div onMouseEnter={() => setDropdownOpen(true)} onMouseLeave={() => setDropdownOpen(false)} className="z-100 bg-white text-black bg-neutral-primary-medium border border-default-medium rounded-base shadow-lg w-44 absolute">
                        <ul className=''>
                          <li className="inline-flex items-center w-full p-3 hover:bg-gray-300"><Link to="/acceptedcontainers">Accepted Containers</Link></li>
                          <li className="inline-flex items-center w-full p-3 hover:bg-gray-300 "><Link to="/returnprocess">Return Process</Link></li>
                        </ul>
                      </div>
                    }

                  </li>

                  <li className='p-2'><a href="https://www.facebook.com/nybottledepot1"><img src={FBLogo} alt="Facebook Logo"></img></a></li>
                  <li className='p-2'><a href="https://www.instagram.com/nybottledepot/"><img src={InstaLogo} alt="Instagram Logo"></img></a></li>
                  <li className='p-2'><a href="https://twitter.com/nybottledepot"><img src={TwitterLogo} alt="Twitter Logo"></img></a></li>

                </ul>
              </div>
            </motion.div>

        </motion.nav>
      </motion.header>
    </main>
  );
}

export default Navbar;

